import axiosInstance from '../main/axios';
import { showTabs, selectTab } from '../common/tab/tabActions';

export function getFasesMonitoradas() {
  const request = axiosInstance.get('/trafego/fases');
  return { type: 'TRAFEGO_FASES_FETCHED', payload: request };
}

export function getResumo() {
  const request = axiosInstance.get('/trafego/resumo');
  return { type: 'TRAFEGO_RESUMO_FETCHED', payload: request };
}

export function getMedicoes(controladorId, faseId, horas = 24) {
  if (!controladorId || !faseId) {
    return { type: 'TRAFEGO_MEDICOES_FETCHED', payload: Promise.resolve({ data: { medicoes: [] } }) };
  }
  const request = axiosInstance.get('/trafego/medicoes', {
    params: { controlador_id: controladorId, fase_id: faseId, horas },
  });
  return { type: 'TRAFEGO_MEDICOES_FETCHED', payload: request };
}

export function limparMedicoes() {
  return { type: 'TRAFEGO_MEDICOES_FETCHED', payload: { data: { medicoes: [] } } };
}

export function getBaseline(controladorId, faseId) {
  if (!controladorId || !faseId) {
    return { type: 'TRAFEGO_BASELINE_FETCHED', payload: { data: { horas: [] } } };
  }
  const request = axiosInstance.get('/trafego/baseline', {
    params: { controlador_id: controladorId, fase_id: faseId },
  });
  return { type: 'TRAFEGO_BASELINE_FETCHED', payload: request };
}

export function limparBaseline() {
  return { type: 'TRAFEGO_BASELINE_FETCHED', payload: { data: { horas: [] } } };
}

export function init() {
  return [showTabs('tabMonitor'), selectTab('tabMonitor'), getFasesMonitoradas(), getResumo()];
}
